var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":""}},_vm._l((_vm.cards),function(card,index){return _c('v-col',{key:index,attrs:{"cols":"12","md":"3"}},[_c('AssetsCard',_vm._b({},'AssetsCard',card,false))],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }